module.exports = __webpack_public_path__ + "static/signaturewhite-f1051ffeaa676792348dc786f9494c05.png";